import { object, string, date } from "yup";
import { Fragments } from "requests";

export const getValidation = (
  initialValues?: Fragments.StoredVitalComment | null
) => {
  const validationSchema = object().shape({
    comments: string().default(""),
    qualityRecovery: string()
      .nullable()
      .default(null),
    timeExtubation: date()
      .default(null)
      .nullable()
  });

  return {
    validationSchema,
    defaultValues: validationSchema.cast({
      comments: initialValues?.comment || "",
      qualityRecovery: initialValues?.qualityRecovery || null,
      timeExtubation: initialValues?.timeExtubation || null
    })
  };
};
